import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import { Suspicion } from './suspicion';

export class User {
  constructor (
    public name: string,
    public password: string
  ) {}
}

@Injectable()
export class ZoonosesService {
  public user: User = new User('', '');

  constructor(private http: Http, private router: Router) { }

  getZoonoses() {
    const headers: Headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(this.user.name + ':' + this.user.password));
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    // headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get('https://ws.senegal.one-health.avia-gis.com/zoonoses', {headers: headers})
      .map(response => response.json());
  }

  getDiseases(id) {
    const headers: Headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(this.user.name + ':' + this.user.password));
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    // headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get('https://ws.senegal.one-health.avia-gis.com/diseases/' + id, {headers: headers})
      .map(response => response.json());
  }

  login(user) {
    this.user = user;
    this.router.navigate(['/']);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/zoonoses.service.ts